<script setup lang="ts">
import { useVModel } from '@vueuse/core'

import RewardSelectionModal from '@/components/ui/RewardSelectionModal.vue'
import OfferRewardModal from '@/views/offer/components/OfferRewardModal.vue'

import type { LoyaltyReward } from '@/types/types'

const props = defineProps<{
  selectedRewardId?: number | null
  isSelectionModalOpen: boolean
  isCreateEditRewardModalOpen: boolean
  rewards: LoyaltyReward[]
}>()

const emit = defineEmits<{
  (e: 'selectReward', rewardId: number): void
  (e: 'update:reward', reward: LoyaltyReward): void
}>()

const selectedRewardId = useVModel(props, 'selectedRewardId')
const isSelectionModalOpen = useVModel(props, 'isSelectionModalOpen')
const isCreateEditRewardModalOpen = useVModel(props, 'isCreateEditRewardModalOpen')

const initialRewardId = ref<number | null>(props.selectedRewardId ?? null)

const selectedReward = computed(() => props.rewards.find((reward) => reward.id === selectedRewardId.value))

const handleSelectReward = (rewardId: number) => {
  selectedRewardId.value = rewardId

  emit('selectReward', rewardId)

  isSelectionModalOpen.value = false
  isCreateEditRewardModalOpen.value = false
}

const handleCreateReward = () => {
  initialRewardId.value = selectedRewardId.value ?? null
  selectedRewardId.value = null
  isSelectionModalOpen.value = false
  isCreateEditRewardModalOpen.value = true
}

const handleCloseEditModal = () => {
  if (initialRewardId.value) {
    selectedRewardId.value = initialRewardId.value
  }

  isCreateEditRewardModalOpen.value = false
}

const handleOfferRewardUpdated = (reward: LoyaltyReward) => {
  emit('update:reward', reward)
}
</script>

<template>
  <RewardSelectionModal
    :is-open="isSelectionModalOpen"
    :rewards="rewards"
    show-edit-button
    :show-points="false"
    :allow-offer-rewards="true"
    @close-modal="() => (isSelectionModalOpen = false)"
    @create-reward="handleCreateReward"
    @select-reward="handleSelectReward"
  />

  <OfferRewardModal
    v-if="isCreateEditRewardModalOpen"
    :reward-id="selectedReward?.id"
    @close="handleCloseEditModal"
    @update:reward="handleOfferRewardUpdated"
  />
</template>
